var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Liên kết tài khoản và tạo VA",
            "before-close": _vm.handleClose,
            visible: _vm.isOTPAuthenticationOCBDialog,
            "show-close": true,
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOTPAuthenticationOCBDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                "label-width": "140px",
                model: _vm.formData,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Tên trường", prop: "merchant_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập tên trường" },
                    model: {
                      value: _vm.formData.merchant_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "merchant_name", $$v)
                      },
                      expression: "formData.merchant_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Email", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập email" },
                    model: {
                      value: _vm.formData.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Địa chỉ trường", prop: "merchant_address" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "1000",
                      "show-word-limit": "",
                      type: "textarea",
                      placeholder: "Nhập địa chỉ trường",
                    },
                    model: {
                      value: _vm.formData.merchant_address,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "merchant_address", $$v)
                      },
                      expression: "formData.merchant_address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Số VA", prop: "va" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Nhập số VA",
                      maxlength: "15",
                      "show-word-limit": "",
                      disabled: "",
                    },
                    model: {
                      value: _vm.formData.va,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "va", $$v)
                      },
                      expression: "formData.va",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tên gợi nhớ", prop: "label" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Nhập tên gợi nhớ",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.label,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "label", $$v)
                      },
                      expression: "formData.label",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Nhập mã OTP", prop: "otp" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "Nhập mã OTP" },
                    model: {
                      value: _vm.formData.otp,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "otp", $$v)
                      },
                      expression: "formData.otp",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.canRequestOTP || _vm.showResendOTP,
                        type: "success",
                        size: "medium",
                      },
                      on: { click: _vm.getOTP },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lấy OTP")]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", [
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "primary",
                      size: "medium",
                      loading: _vm.loading.submit,
                    },
                    on: { click: _vm.submitForm },
                  },
                  [
                    _c("i", { staticClass: "el-icon-circle-check" }),
                    _c("span", [_vm._v("Liên kết")]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                "text-align": "center",
                "font-size": "14px",
              },
            },
            [
              _vm._v(
                "\n      Trong trường hợp không nhận được mã OTP hoặc mã OTP hết hiệu lực, bạn có thể nhấn\n      "
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "min-width": "100px" },
                  attrs: {
                    type: "primary",
                    size: "medium",
                    disabled: _vm.countdown > 0,
                  },
                  on: { click: _vm.resendOTP },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.countdown > 0
                          ? `Gửi lại mã (${_vm.countdown}s)`
                          : "Gửi lại mã"
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }